import DepositModal from '@features/games/deposit/deposit-modal';
export default DepositModal;
